import LocalizedStrings from 'react-localization';

const english = {
    Action_Cancel: 'Cancel',
    Action_ClearFilters: 'Clear filters',
    Action_ClearSelected: 'Clear Selected',
    Action_Close: 'Close',
    Action_Delete: 'Delete',
    Action_Edit: 'Edit',
    Action_Export: 'Export Data',
    Action_ManageColumn: 'Manage Columns',
    Action_No: 'No',
    Action_Refresh: 'Refresh',
    Action_SaveSelected: 'Save Selected',
    Action_View: 'View',
    Action_Yes: 'Yes',

    ClearSearch: 'Clear Search',
    Further_Options: 'Further Options',
    Manage_Columns: 'Manage Columns',

    Label_25_PerPage: '25 per page',
    Label_50_PerPage: '50 per page',
    Label_100_PerPage: '100 per page',
    Label_250_PerPage: '250 per page',
    Label_500_PerPage: '500 per page',
    Label_Loading: 'Loading...',
    Label_Search: 'Search',
    Label_ClearSearch: 'Clear Search',
    Label_Select: "Select...",

    Action_MoveToTheFirstPage: 'Move to the first page',
    Action_MoveToThePreviousPage: 'Move to the previous page',
    Action_MoveToTheNextPage: 'Move to the next page',
    Action_MoveToTheLastPage: 'Move to the last page',
    Action_ResetToDefault: 'Reset To Default',

    Message_UnknownError: `An unknown error has occurred, please refresh your browser`,

    // AG Grid
    Label_SituationResponseNotOK: 'Situation Response: Not Okay',

    // Search
    Search_Label_NoResultsFound: 'No Results Found',
    Search_Label_OneResultFound: '1 Result Found',
    Search_Label_MoreResultsFound: ' Results Found',

    // FilterBar
    FilterBar_Label_AddFilter: 'Add Filter',
    FilterBar_Label_EditFilter: 'Edit Filter',
    FilterBar_Label_FixedFilter: 'Fixed Filter cannot be removed',
    FilterBar_Label_RemoveFilter: 'Remove Filter',
    FilterBar_Label_IsMissing: '{0} is missing a value',
    FilterBar_Label_Is: 'is',
    FilterBar_Label_PlusMore: '+ More',
    FilterBar_Label_NotProvided: '(Not Provided)',

    VisitorBannedMarker_Label_VisitorBanned: 'Banned',
    VisitorHoldMarker_Label_VisitorHold: 'Visitor Hold',
};

export const strings = new LocalizedStrings({
    en: {
        ...english,
    },
    'en-US': {
        ...english,
    },
});
